module.exports = __webpack_public_path__ + "static/media/2024.07.31 - Administrative Penalty Order- Mariman Homes.e69e4b2d.pdf";